module.exports = __webpack_public_path__ + "static/media/KickHomepage.25100cbc.png";